import React from 'react';
import styles from './ResponsiveSection.module.scss';

/**
 * Simple component that will provide consistent widths and margins
 * at multiple screen sizes.
 * For mobile devices, the max-width is kept at 1440px
 */
export const ResponsiveSection: React.FunctionComponent<{}> = (props) => {
    return (
        <section className={styles.responsiveSection}>{props.children}</section>
    );
};
